// extracted by mini-css-extract-plugin
export default {"content":"pageDesign_content__qeZ4t"};